import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import { Subscription } from "rxjs";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class NetworkErrorConnectionService {
  public apiUrl = environment.serverUrl;
  status!: string;
  // currentState!: ConnectionState;
  subscription = new Subscription();

  constructor( private router: Router) {
  }

  getConnectionStatus() {
    return this.status;
  }

  checkConnection() {
  //   const options: ConnectionServiceOptions = {
  //     enableHeartbeat: false,
  //     heartbeatUrl: this.apiUrl,
  //     heartbeatInterval: 100,
  //   };
  //   return this.connectionService.monitor(options).pipe(
  //     tap((newState: ConnectionState) => {
  //       this.currentState = newState;
  //       if (this.currentState.hasNetworkConnection && this.currentState.hasInternetAccess) {
  //         this.status = "ONLINE";
  //         console.log(this.status);
  //       } else {
  //         this.router.navigate(["/oops/error-internet-connection"]);
  //       }
  //     }),
  //   );
   }
}
